import { Stack, Typography } from '@mui/material';
import LassoSelect from './LassoSelect';
import { colours } from '../StyleConstants';
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedDatabase, setSelectedDatabase } from '../features/common/databaseSlice';
import { useGetDatabaseLocationsQuery, useGetDatabaseVersionQuery } from "../api/databaseApiSlice";
import { adwUpdateSelectedFile, reset, setSelectedQueryTool } from '../features/data-wrangler/dataWranglerSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { useUserInfoQuery } from '../api/userApiSlice';

const DatabaseSelector = () => {
    const dispatch = useDispatch();
    const database = useSelector(selectSelectedDatabase);
    const { data: availableDatabases } = useGetDatabaseLocationsQuery();
    const { data: version } = useGetDatabaseVersionQuery({ database });
    const location = useLocation();
    const navigate = useNavigate();
    const { data: userData } = useUserInfoQuery({});
    const isGuestUser = userData?.id === -1

    const onChange = (e: any) => {
        const database = availableDatabases?.find(
            (database) => database.database === e.target.value
        );
        if (database) {
            dispatch(setSelectedDatabase(database));
            dispatch(reset({ "exemptKeys": { "selectedQueryTool": "allStudyData" } })); // Reset query wizard selection
            if(!isGuestUser){
                dispatch(adwUpdateSelectedFile({})); //resets ongoing queries for the file transfer
            }
        }
        if (location.pathname.replace(/^\/+/,'') === 'globus-collections') {
            dispatch(setSelectedQueryTool("allStudyData"));
            navigate("/data-wrangler");
        }
    };

    return (
        <Stack id="database-selector-form" gap={2} component="form" onSubmit={(e: any) => {
            e.preventDefault()
        }}>
            <LassoSelect
                id="database-selector-dropdown"
                sx={{
                    border: '2px solid white',
                    borderRadius: "8px",
                    backgroundColor: "transparent",
                    color: "white",
                    ".MuiSvgIcon-root.MuiSelect-icon": {
                        color: "white",
                    },
                    ".Mui-focusVisible": {
                        border: "2px solid #80B7F8",
                    }
                }}
                inputProps={{
                    "aria-label": "Select Study"
                }}
                value={database || ""}
                onChange={onChange}
                options={availableDatabases?.map((item: any) => ({ label: item.name, value: item.database }))}
            />
            <Stack flexDirection="row" justifyContent="center" alignItems="center" gap={1}>
                <Typography fontSize="12px" color={colours.core.white}>
              Version:
                </Typography>
                <span
                    id="database-selector-currently-selected-database-version"
                    style={{ fontSize: '14px', fontWeight: 600, color: colours.core.white }}
                >
                    {version || ""}
                </span>
            </Stack>
        </Stack>
    )
}

export default DatabaseSelector;